import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a4afb19e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "drag-handler top" }, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "drag-handler bottom" }, null, -1))

import { computed, onMounted, onUnmounted, PropType, ref, watch } from "vue";
import { storeToRefs } from "pinia";
import { debounce } from "lodash";
import { useMainStore, useSlidesStore } from "@/store";
import { PPTTextElement } from "@/types/slides";
import { ContextmenuItem } from "@/components/Contextmenu/types";
import useElementShadow from "@/views/components/element/hooks/useElementShadow";
import useHistorySnapshot from "@/hooks/useHistorySnapshot";

import ElementOutline from "@/views/components/element/ElementOutline.vue";
import ProsemirrorEditor from "@/views/components/element/ProsemirrorEditor.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  elementInfo: {
    type: Object as PropType<PPTTextElement>,
    required: true,
  },
  selectElement: {
    type: Function as PropType<
      (
        e: MouseEvent | TouchEvent,
        element: PPTTextElement,
        canMove?: boolean
      ) => void
    >,
    required: true,
  },
  contextmenus: {
    type: Function as PropType<() => ContextmenuItem[] | null>,
  },
},
  setup(__props) {

const props = __props;



const mainStore = useMainStore();
const slidesStore = useSlidesStore();
const { handleElementId, isScaling } = storeToRefs(mainStore);

const { addHistorySnapshot } = useHistorySnapshot();

const elementRef = ref<HTMLElement>();

const shadow = computed(() => props.elementInfo.shadow);
const { shadowStyle } = useElementShadow(shadow);

const handleSelectElement = (e: MouseEvent | TouchEvent, canMove = true) => {
  if (props.elementInfo.lock) return;
  e.stopPropagation();

  props.selectElement(e, props.elementInfo, canMove);
};

// 监听文本元素的尺寸变化，当高度变化时，更新高度到vuex
// 如果高度变化时正处在缩放操作中，则等待缩放操作结束后再更新
const realHeightCache = ref(-1);
const realWidthCache = ref(-1);

watch(isScaling, () => {
  if (handleElementId.value !== props.elementInfo.id) return;

  if (!isScaling.value) {
    if (!props.elementInfo.vertical && realHeightCache.value !== -1) {
      slidesStore.updateElement({
        id: props.elementInfo.id,
        props: { height: realHeightCache.value },
      });
      realHeightCache.value = -1;
    }
    if (props.elementInfo.vertical && realWidthCache.value !== -1) {
      slidesStore.updateElement({
        id: props.elementInfo.id,
        props: { width: realWidthCache.value },
      });
      realWidthCache.value = -1;
    }
  }
});

const updateTextElementHeight = (entries: ResizeObserverEntry[]) => {
  const contentRect = entries[0].contentRect;
  if (!elementRef.value) return;

  const realHeight = contentRect.height + 20;
  const realWidth = contentRect.width + 20;

  if (!props.elementInfo.vertical && props.elementInfo.height !== realHeight) {
    if (!isScaling.value) {
      slidesStore.updateElement({
        id: props.elementInfo.id,
        props: { height: realHeight },
      });
    } else realHeightCache.value = realHeight;
  }
  if (props.elementInfo.vertical && props.elementInfo.width !== realWidth) {
    if (!isScaling.value) {
      slidesStore.updateElement({
        id: props.elementInfo.id,
        props: { width: realWidth },
      });
    } else realWidthCache.value = realWidth;
  }
};
const resizeObserver = new ResizeObserver(updateTextElementHeight);

onMounted(() => {
  if (elementRef.value) resizeObserver.observe(elementRef.value);
});
onUnmounted(() => {
  if (elementRef.value) resizeObserver.unobserve(elementRef.value);
});

const updateContent = (content: string) => {
  slidesStore.updateElement({
    id: props.elementInfo.id,
    props: { content },
  });

  addHistorySnapshot();
};

const checkEmptyText = debounce(
  function () {
    const pureText = props.elementInfo.content.replaceAll(/<[^>]+>/g, "");
    if (!pureText) slidesStore.deleteElement(props.elementInfo.id);
  },
  300,
  { trailing: true }
);

const isHandleElement = computed(
  () => handleElementId.value === props.elementInfo.id
);
watch(isHandleElement, () => {
  if (!isHandleElement.value) checkEmptyText();
});

return (_ctx: any,_cache: any) => {
  const _directive_contextmenu = _resolveDirective("contextmenu")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["editable-element-text", { lock: __props.elementInfo.lock }]),
    style: _normalizeStyle({
      top: __props.elementInfo.top + 'px',
      left: __props.elementInfo.left + 'px',
      width: __props.elementInfo.width + 'px',
      height: __props.elementInfo.height + 'px',
    })
  }, [
    _createElementVNode("div", {
      class: "rotate-wrapper",
      style: _normalizeStyle({ transform: `rotate(${__props.elementInfo.rotate}deg)` })
    }, [
      _withDirectives((_openBlock(), _createElementBlock("div", {
        class: "element-content",
        ref_key: "elementRef",
        ref: elementRef,
        style: _normalizeStyle({
          width: __props.elementInfo.vertical ? 'auto' : __props.elementInfo.width + 'px',
          height: __props.elementInfo.vertical ? __props.elementInfo.height + 'px' : 'auto',
          backgroundColor: __props.elementInfo.fill,
          opacity: __props.elementInfo.opacity,
          textShadow: _unref(shadowStyle),
          lineHeight: __props.elementInfo.lineHeight,
          letterSpacing: (__props.elementInfo.wordSpace || 0) + 'px',
          color: __props.elementInfo.defaultColor,
          fontFamily: __props.elementInfo.defaultFontName,
          writingMode: __props.elementInfo.vertical ? 'vertical-rl' : 'horizontal-tb',
        }),
        onMousedown: _cache[2] || (_cache[2] = ($event) => handleSelectElement($event)),
        onTouchstart: _cache[3] || (_cache[3] = ($event) => handleSelectElement($event))
      }, [
        _createVNode(ElementOutline, {
          width: __props.elementInfo.width,
          height: __props.elementInfo.height,
          outline: __props.elementInfo.outline
        }, null, 8, ["width", "height", "outline"]),
        _createVNode(ProsemirrorEditor, {
          class: "text",
          elementId: __props.elementInfo.id,
          defaultColor: __props.elementInfo.defaultColor,
          defaultFontName: __props.elementInfo.defaultFontName,
          editable: !__props.elementInfo.lock,
          value: __props.elementInfo.content,
          style: _normalizeStyle({
            '--textIndent': `${__props.elementInfo.textIndent || 0}px`,
            '--paragraphSpace': `${
              __props.elementInfo.paragraphSpace === undefined
                ? 5
                : __props.elementInfo.paragraphSpace
            }px`,
          }),
          onUpdate: _cache[0] || (_cache[0] = (value) => updateContent(value)),
          onMousedown: _cache[1] || (_cache[1] = ($event) => handleSelectElement($event, false))
        }, null, 8, ["elementId", "defaultColor", "defaultFontName", "editable", "value", "style"]),
        _hoisted_1,
        _hoisted_2
      ], 36)), [
        [_directive_contextmenu, __props.contextmenus]
      ])
    ], 4)
  ], 6))
}
}

})